<main id="content" role="main" class="main">
  <!-- Content -->
  <div class="content container">
    <div >
      <nav aria-label="breadcrumb">
        <ol id="w1" class="breadcrumb">
          <li class="breadcrumb-item">الرئيسية</li>
          <li class="breadcrumb-item active" aria-current="page">الشركات</li>
        </ol>
      </nav>
    </div>
    <div class="company-index" >

      <h1>الشركات</h1>



      <div id="w0" class="grid-view">
        <div class="summary">Showing <b>1-20</b> of <b>3,224</b> items.</div>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th><a href="/company/index?company=&amp;sort=national_id" data-sort="national_id">National ID</a></th>
              <th><a href="/company/index?company=&amp;sort=name" data-sort="name">Establishment Name</a></th>
              <th><a href="/company/index?company=&amp;sort=company_type" data-sort="company_type">Establishment
                  Type</a></th>
              <th><a class="desc" href="/company/index?company=&amp;sort=status" data-sort="status">الحالة</a></th>
              <th><a href="/company/index?company=&amp;sort=created_at" data-sort="created_at">Submission Date</a></th>
              <th><a href="/company/index?company=&amp;sort=updated_at" data-sort="updated_at">Last update</a></th>
              <th class="action-column">&nbsp;</th>
            </tr>
            <tr id="w0-filters" class="filters">
              <td>&nbsp;</td>
              <td><input type="text" class="form-control" name="natinoalId" [(ngModel)]="natinoalId" (blur)="search()"></td>
              <td><input type="text" class="form-control" name="establishName" [(ngModel)]="establishName" (blur)="search()"></td>
              <td><input type="text" class="form-control" name="establishType" [(ngModel)]="establishType" (blur)="search()"></td>
              <td><input type="text" class="form-control" name="CompanySearch[status]"></td>
              <td><input type="text" class="form-control" name="CompanySearch[created_at]"></td>
              <td><input type="text" class="form-control" name="CompanySearch[updated_at]"></td>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            <tr data-key="3225" *ngFor="let item of requests;let i=index">
              <td>{{item.id}}</td>
              <td>
                <a href="/{{mainPath}}/CompanyInfo?id={{item.establishmentNatId}}" title="View" aria-label="View" data-pjax="0">
                  {{item.establishmentNatId}}
                </a>
              </td>
              <td>{{item.companyName}}</td>
              <td>{{item.establishmentType}}</td>
              <td><span class="badge bg-soft-warning text-dark">
                  <span class="legend-indicator bg-warning mr-2" ></span> قيد الإنتظار
                </span></td>
              <td>{{item.created|date:'dd/MM/yyyy'}}</td>
              <td>{{item.lastModified|date:'dd/MM/yyyy'}}</td>
              <td><a href="/{{mainPath}}/CompanyInfo?id={{item.establishmentNatId}}" title="View" aria-label="View" data-pjax="0"><svg aria-hidden="true"
                    style="display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em;width:1.125em"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                    <path fill="currentColor"
                      d="M573 241C518 136 411 64 288 64S58 136 3 241a32 32 0 000 30c55 105 162 177 285 177s230-72 285-177a32 32 0 000-30zM288 400a144 144 0 11144-144 144 144 0 01-144 144zm0-240a95 95 0 00-25 4 48 48 0 01-67 67 96 96 0 1092-71z">
                    </path>
                  </svg></a></td>
            </tr>

          </tbody>
        </table>
        <ul class="pagination">
          <li class="prev"><span (click)="goPrevIndex()">«</span></li>
         
          <li [ngClass]="item==currentIndex?'active':null" *ngFor="let item of pages| slice:currentIndex-1:currentIndex+9"><a (click)="updatePagination(item)">{{item}}</a></li>
          <li class="next"><a (click)="goNextIndex()" data-page="1">»</a></li>
      </ul>
      </div>
    </div>
  </div>
</main>